import { t } from 'translations'

const getRangeForButton = (start?: string, end?: string) => {
  if (!start || !end) return t(`searchBar.DATES`)
  if (start === end) return start
  return `${start} - ${end}`
}

export default getRangeForButton
